import React, { useState } from 'react';
import './EmailModal.css';

function EmailModal({ onEmailSubmit, onClose, recipesRemaining, isRequired }) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitting(true);
      await onEmailSubmit(email);
      setIsSubmitting(false);
    }
  };

  // Determine the message based on recipes remaining
  const getMessage = () => {
    if (isRequired) {
      return "You've created 5 mocktails! Enter your email to keep going.";
    } else if (recipesRemaining <= 2) {
      return `You have ${recipesRemaining} mocktail${recipesRemaining === 1 ? '' : 's'} left to mix. Enter your email to unlock unlimited mocktails!`;
    } else {
      return "Want to save this recipe? Enter your email to unlock save, share, and unlimited mocktails!";
    }
  };

  return (
    <div className="email-modal-overlay">
      <div className="email-modal-content">
        {!isRequired && (
          <button 
            className="modal-close-button" 
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}
        
        <div className="modal-icon">🍹</div>
        
        <h2 className="modal-title">{getMessage()}</h2>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            className="modal-email-input"
            autoFocus
          />
          
          <p className="modal-disclaimer">
            Join the RYSL community! You'll receive occasional mocktail inspiration, 
            sobriety tips, and exclusive offers. Unsubscribe anytime.
          </p>
          
          <button 
            type="submit" 
            className="modal-submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Unlocking...' : '✨ Unlock Unlimited Mocktails'}
          </button>
        </form>
        
        {!isRequired && (
          <button 
            className="modal-maybe-later"
            onClick={onClose}
          >
            Maybe Later
          </button>
        )}
      </div>
    </div>
  );
}

export default EmailModal;
